<div id="topbar" class="layout-topbar">
  <a class="logo" href="/">
    <img src="assets/images/png/logo.png" alt="california-logo" />
  </a>
  <a id="menu-button" href="#" (click)="appMain.onMenuButtonClick($event)">
    <i class="pi pi-align-left"></i>
  </a>

  <div id="topbar-menu-button" class="flex align-items-center gap-4">
    @if (app.profileMode==='top' || appMain.isHorizontal()) {
      <a href="#" (click)="appMain.onTopbarMenuButtonClick($event)"
        >
        <img class="avatar" [src]="foto | signUrl | async" alt="avatar" onerror="this.src='assets/images/jpg/avatar.jpg'">
        <span class="username">{{usuario}}</span>
      </a>
    }

    <ul id="topbar-usermenu" class="usermenu usermenu-overlay fadeInDown"
      [ngClass]="{'usermenu-active': appMain.topbarMenuActive}">
      <li #profile [ngClass]="{'menuitem-active':appMain.activeTopbarItem === profile}">
        <a (click)="alterarSenha()">
          <i class="pi pi-fw pi-lock"></i>
          <span class="topbar-item-name">Alterar senha</span>
        </a>
      </li>
      <li #profile [ngClass]="{'menuitem-active':appMain.activeTopbarItem === profile}">
        <a href="#" (click)="logout()">
          <i class="pi pi-fw pi-power-off"></i>
          <span class="topbar-item-name">Sair</span>
        </a>
      </li>
    </ul>
  </div>
</div>